<script>
    import { createEventDispatcher } from "svelte";
    const dispatch = createEventDispatcher();
    let cls = "sui-card";
    export let title = "";
</script>

<div class={cls} on:click>
    <div class={`${cls}-header`} on:click={() => dispatch("headerClick")}>
        {#if title}
            <h4 class={`${cls}-header-title`}>{title}</h4>
        {/if}{#if $$slots.extra}
            <slot name="extra" />
        {/if}
    </div>
    <div class={`${cls}-body`} on:click={() => dispatch("bodyClick")}>
        <slot />
    </div>
</div>

<style lang="less">
    @import "./card.less";
</style>
